// extracted by mini-css-extract-plugin
export var cfgLogoSection = "FooterCfgLogoSection-module--cfgLogoSection--3ff5e";
export var copyright = "FooterCfgLogoSection-module--copyright--182b4 typography-module--bodySmall--d4a98";
export var logo = "FooterCfgLogoSection-module--logo--1c2d9";